import classNames from "@casino/external/classNames";
import getLgPadding from "../padding/getLgPadding";
import getMdPadding from "../padding/getMdPadding";
import getSmPadding from "../padding/getSmPadding";
import getXlPadding from "../padding/getXlPadding";
import getXsPadding from "../padding/getXsPadding";
import type SettingsProps from "../types/SettingsProps";

const getButtonSize = ({
  size,
  iconLeft,
  iconRight,
  fullWidth,
}: SettingsProps): string => {
  if (size === "xs") {
    return classNames(
      getXsPadding({ iconLeft, iconRight, fullWidth }),
      "h-6 py-1 gap-1 text-xs rounded-sm",
    );
  }
  if (size === "sm") {
    return classNames(
      getSmPadding({ iconLeft, iconRight, fullWidth }),
      "h-8 py-1 gap-1 text-sm/6 rounded-lg",
    );
  }
  if (size === "lg") {
    return classNames(
      getLgPadding({ iconLeft, iconRight, fullWidth }),
      "h-12 py-3 gap-2 text-base rounded-lg",
    );
  }
  if (size === "xl") {
    return classNames(
      getXlPadding({ iconLeft, iconRight, fullWidth }),
      "h-14 py-4 gap-2 text-base rounded-xl",
    );
  }
  return classNames(
    getMdPadding({ iconLeft, iconRight, fullWidth }),
    "h-10 py-2 gap-2 text-sm/6 rounded-lg",
  );
};

export default getButtonSize;
